// The page under a modal does not scroll: overflow hidden on the body, with
// the scroll bar's room kept. Not the body-scroll-lock package: on iOS it
// cancels every one-finger move that is not on a locked element that
// scrolls itself, so a modal's inner scroller only moved with two fingers.
// iOS Safari honours overflow hidden on the body since 16.
let previousBody
let previousNavPaddingRight
let previousAppBgWrapperRight
const lockerEls = new Set([])

const disableBodyScroll = (el) => {
  const scrollBarGap = window.innerWidth - document.documentElement.clientWidth
  if (previousBody === undefined) {
    const { overflow, paddingRight } = document.body.style
    previousBody = { overflow, paddingRight }
    if (scrollBarGap > 0) document.body.style.paddingRight = `${scrollBarGap}px`
    document.body.style.overflow = 'hidden'
  }
  lockerEls.add(el)
  setTimeout(() => {
    if (lockerEls.size <= 1) {
      // If previousNavPaddingRight is already set, don't set it again.
      if (previousNavPaddingRight === undefined) {
        const navEl = document.getElementById('nav')
        previousNavPaddingRight = window
          .getComputedStyle(navEl)
          .getPropertyValue('padding-right')
        navEl.style.paddingRight = previousNavPaddingRight
          ? `calc(${previousNavPaddingRight} + ${scrollBarGap}px)`
          : `${scrollBarGap}px`
      }
      // If previousAppBgWrapeprRight is already set, don't set it again.
      if (previousAppBgWrapperRight === undefined) {
        const appBgWrapperEl = document.getElementById('app_bg_wrapper')
        previousAppBgWrapperRight = window
          .getComputedStyle(appBgWrapperEl)
          .getPropertyValue('right')
        appBgWrapperEl.style.right = previousAppBgWrapperRight
          ? `calc(${previousAppBgWrapperRight} + ${scrollBarGap}px)`
          : `${scrollBarGap}px`
      }
      document.body.classList.add('scroll-locked')
    }
  })
}

const enableBodyScroll = (el) => {
  lockerEls.delete(el)
  setTimeout(() => {
    if (lockerEls.size === 0) {
      if (previousNavPaddingRight !== undefined) {
        document.getElementById('nav').style.paddingRight =
          previousNavPaddingRight
        // Restore previousNavPaddingRight to undefined so disableBodyScroll knows it can be set again.
        previousNavPaddingRight = undefined
      }
      if (previousAppBgWrapperRight !== undefined) {
        document.getElementById('app_bg_wrapper').style.right =
          previousAppBgWrapperRight
        // Restore previousAppBgWrapperRight to undefined so disableBodyScroll knows it can be set again.
        previousAppBgWrapperRight = undefined
      }
      document.body.classList.remove('scroll-locked')
    }
  })
  if (lockerEls.size === 0 && previousBody !== undefined) {
    Object.assign(document.body.style, previousBody)
    previousBody = undefined
  }
}

const directive = {
  mounted: (el, binding) => {
    if (binding.value) {
      disableBodyScroll(el)
    }
  },
  updated: (el, binding) => {
    if (binding.oldValue === binding.value) {
      return
    }

    if (binding.value) {
      disableBodyScroll(el)
    } else {
      enableBodyScroll(el)
    }
  },
  unmounted: (el) => {
    enableBodyScroll(el)
  },
}

export default (Vue) => {
  Vue.directive('body-scroll-lock', directive)
}
